import React from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

const NavLinks = ({ isDarkMode = false }) => {
  const linkClassName = `px-4 font-extrabold hover:text-[#377c7d] transition-colors ${
    isDarkMode ? "text-gray-300 hover:text-[#4a9fa0]" : "text-gray-500"
  }`;

  return (
    <>
      <HashLink className={linkClassName} smooth to="/#about">
        About
      </HashLink>
      <HashLink className={linkClassName} smooth to="/#services">
        Services
      </HashLink>
      <HashLink className={linkClassName} smooth to="/#technologies">
        Technologies
      </HashLink>
      <Link className={linkClassName} to="/portfolio">
        Portfolio
      </Link>
      <HashLink className={linkClassName} to="/career#career">
        Career
      </HashLink>

      <HashLink className={linkClassName} to="/blogs#blogs">
        Blogs
      </HashLink>

      <HashLink className={linkClassName} to="/contact#contact">
        Contact Us
      </HashLink>
    </>
  );
};

export default NavLinks;
